module.exports = __webpack_public_path__ + "static/media/groupHost.9ddc32a8.svg";